export default __webpack_public_path__ + "static/media/product.b74ac8e8.png";